import React, { FC } from 'react'
import { FormProvider } from 'react-hook-form'
import { Button } from '@wmgtech/legato'

import { FormAdminContainer } from 'components'
import { UserForm } from 'modules/Users/components'
import { useUpdateUser } from 'modules/Users/serviceHooks'

const UpdateUser: FC = () => {
  const {
    onSubmit,
    handleSubmit,
    isSubmitButtonDisabled,
    control,
    userRolesOptions,
    isExternalEmail,
    methods,
  } = useUpdateUser()

  return (
    <FormAdminContainer
      backLink="/admin/users"
      actions={(
        <Button
          htmlType="submit"
          label="Save"
          colorType="secondary-white"
          containerStyle="outline"
          disabled={isSubmitButtonDisabled}
          form="user-form"
        />
      )}>
      <FormProvider {...methods}>
        <UserForm
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          isSubmitButtonDisabled={isSubmitButtonDisabled}
          control={control}
          isExternalEmail={isExternalEmail}
          userRolesOptions={userRolesOptions}
        />
      </FormProvider>
    </FormAdminContainer>
  )
}

export default UpdateUser
